import {
  Action,
  OperationType,
  Position, WarningType
} from "puzzle";

export const reloadDashboard: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'userPromise',
  type: OperationType.action
}, {
  condition: '{initializeUserData.hasActiveProjects}',
  conditionOperations: [{
    name: 'getFavoriteFilters',
    type: OperationType.action
  }, {
    moduleName: 'Dashboard',
    name: 'setPreferenceData',
    args: ['preferencesData'],
    type: OperationType.addOperationData
  }, {
    name: 'getMainGridInitialData',
    type: OperationType.action
  }],
  elseOperations: [{
    items: [{
      btnName: 'noProjectAssignedWarning.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }],
    placeholders: {
      template: {
        bind: {
          sendMailTo: '{initializeUserData.administratorEmail}',
          emailDisplayText: '{initializeUserData.administratorEmail}'
        }
      }
    },
    className: 'sm confirm-light',
    text: 'noProjectAssignedWarning.infoText',
    title: 'noProjectAssignedWarning.title',
    type: OperationType.warning,
    warningType: WarningType.info
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];
